// Components
import Image from 'next/image';

import Banner from 'public/images/giveaway-picker/giveaway-picker-banner.svg';

// Hooks
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { AlertLogo } from '@/components/pages/giveaway-picker/components/Icons/AlertLogo';
import { InstagramLogo } from '@/components/pages/giveaway-picker/components/Icons/InstagramLogo';

export function GiveawayPickerBanner() {
    const { t } = useTranslation('giveaway_picker');

    return (
        <div
            className="relative hidden w-[400px] gap-8 overflow-hidden rounded-2xl bg-icoBlue-100 p-10 lg:flex lg:flex-row"
            data-testid="giveaway-picker-banner">
            <div>
                <p className="flex gap-2 text-xl text-icoBlue">
                    <span>Instagram</span>
                    <span className="relative flex items-center">
                        <InstagramLogo />
                        <span className="absolute -right-2 -top-1 translate-x-px">
                            <AlertLogo />
                        </span>
                    </span>
                </p>
                <p className="text-xl">{t('title')}</p>
            </div>
            <Image
                src={Banner}
                width={210}
                height={210}
                alt="giveaway-picker-banner"
                className="absolute -right-6 -top-9 rotate-[4deg]"
                data-testid="giveaway-picker-banner-image"
            />
        </div>
    );
}
